import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBookOpenText = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 7.55556V20M12 7.55556C12 6.61256 11.6207 5.70819 10.9456 5.0414C10.2705 4.3746 9.35478 4 8.4 4H3.9C3.66131 4 3.43239 4.09365 3.2636 4.26035C3.09482 4.42705 3 4.65314 3 4.88889V16.4444C3 16.6802 3.09482 16.9063 3.2636 17.073C3.43239 17.2397 3.66131 17.3333 3.9 17.3333H9.3C10.0161 17.3333 10.7028 17.6143 11.2092 18.1144C11.7155 18.6145 12 19.2928 12 20M12 7.55556C12 6.61256 12.3793 5.70819 13.0544 5.0414C13.7295 4.3746 14.6452 4 15.6 4H20.1C20.3387 4 20.5676 4.09365 20.7364 4.26035C20.9052 4.42705 21 4.65314 21 4.88889V16.4444C21 16.6802 20.9052 16.9063 20.7364 17.073C20.5676 17.2397 20.3387 17.3333 20.1 17.3333H14.7C13.9839 17.3333 13.2972 17.6143 12.7908 18.1144C12.2845 18.6145 12 19.2928 12 20M15.6 12H17.4M15.6 8.44444H17.4M6.6 12H8.4M6.6 8.44444H8.4",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgBookOpenText);
export { ForwardRef as ReactComponent };
